export const POSITION_LANGUAGE = {
    ES: 0,
    EN: 1,
    PT: 2,
};
